import styled, { css } from 'styled-components';

import { styles } from '../../styles';

const size = {
  sm: css`
    padding: 0px 8px;
    ${styles.rounded.md};
  `,
  smd: css`
    padding: 6px 12px;
  `,
  md: css`
    padding: 12px 16px;
  `,
};

const types = {
  primary: css`
    ${styles.bg.primary};
    ${styles.color.textOnPrimary};
  `,
  danger: css`
    ${styles.bg.danger};
    ${styles.color.textOnDanger};
  `,
  default: css`
    ${styles.bg.border};
    ${styles.color.textOnBorder};
  `,
  success: css`
    ${styles.bg.success}
    ${styles.color.textOnSuccess}
  `,
};

const interactive = css`
  cursor: pointer;
  :hover {
    filter: brightness(0.9);
  }
  :active {
    filter: brightness(1.03);
  }
`;

export const Item = styled.div<{
  size?: keyof typeof size;
  t?: keyof typeof types;
}>`
  ${(props) => (props.onClick ? interactive : '')};
  ${(props) => size[props.size || 'md']};
  ${(props) => types[props.t || 'default']};
  ${styles.transition.default}
`;
